module.exports = __webpack_public_path__ + "img/nosearchdata-min.3cd7bbbd.png";